export default {
  state: {
    modal: null,
    webview_mode: false,
    readyForRequests: false,
    AppValidating: false
  },
  mutations: {
    setModal(state, params) {
        state.modal = params
    },
    setWebviewMode(state) {
        state.webview_mode = true
    },
    closeModal(state) {
      state.modal = null
    },
    readyForRequests(state, val) {
      state.readyForRequests = val
    }
  },
  actions: {
    setWebviewMode({ commit }) {
      commit('setWebviewMode');
    },
    setModal({ commit }, params) {
      commit('setModal', params);
    },
    closeModal({ commit }) {
      commit('closeModal');
    },
    readyForRequests({ commit }, val) {
      commit('readyForRequests', val)
    }
  },
  getters: {
    getModal: (s) => s.modal,
    webViewMode: (s) => s.webview_mode,
    readyForRequests: (s) => s.readyForRequests,
    AppValidating: (s) => s.AppValidating
  },
};
